import { Component } from "@angular/core";
import { AdminService } from "../../app/services/admin.service";
import { UserState } from "../../app/store/reducers/user.reducer";
import { Subscription } from "rxjs/Subscription";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/models/app.state";
import { HcpUsersState } from "../../app/store/reducers/hcp-user.reducer";
import { TranslateService } from "@ngx-translate/core";
import { _i18n_str } from "../../assets/i18n/non-static-ids";
import { IDiaprofilHcp } from "../../app/models/types";
import { ModalController } from "ionic-angular/components/modal/modal-controller";
import { ManageHcpUserModal } from "../../modals/manage-hcp-user.modal/manage-hcp-user.modal";
import * as moment from "moment";
import {
  EventLoggingService,
  LogEventId
} from "../../app/services/event-logging.service";
import { NavController } from "ionic-angular";
import { LogEventListingPage } from "../log-event-listing.page/log-event-listing.page";

@Component({
  selector: "hcp-users-page",
  templateUrl: "hcp-users.page.html"
})
export class HcpUsersPage {
  userState: UserState;
  hcpUsers: HcpUsersState;
  userSubscription: Subscription;
  hcpUsersSubscription: Subscription;
  localizedTableMessages: { [key: string]: string };
  constructor(
    public admin: AdminService,
    private store: Store<AppState>,
    private translate: TranslateService,
    private modalCtrl: ModalController,
    private eventLogging: EventLoggingService,
    private navCtrl: NavController
  ) {
    this.userSubscription = this.store
      .select(state => state.user)
      .subscribe(user => (this.userState = user));
    this.hcpUsersSubscription = this.store
      .select(state => state.hcpUsers)
      .subscribe(hcpUsers => {
        this.hcpUsers = hcpUsers;
        console.log(this.hcpUsers);
      });
    this.localizedTableMessages = {
      // Message to show when array is presented
      // but contains no values
      emptyMessage: translate.instant(
        _i18n_str("HCP_USERS_LISTING.MESSAGES.NO_DATA_TO_DISPLAY")
      ),
      // Footer total message
      totalMessage: translate.instant(
        _i18n_str("HCP_USERS_LISTING.MESSAGES.TOTAL")
      )
    };
    this.eventLogging.saveEvent({
      event_id: LogEventId.OPEN_STAFF_LISTING,
      event_src_location: "HCP_USERS_PAGE"
    });
  }

  deactivationTooltip(user: IDiaprofilHcp) {
    let timeStamp;
    if (user.deactivationTimestamp !== null) {
      timeStamp = moment(new Date(user.deactivationTimestamp)).format(
        "DD-MM-YYYY"
      );
    } else {
      timeStamp = "Mangler angivelse af tidspunkt";
    }
    return `Årsag: ${user.deactivationReason} (${timeStamp})`;
  }

  ionViewWillEnter() {
    this.admin.getHcps(this.userState.organizationUuid);
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.hcpUsersSubscription.unsubscribe();
  }

  goToLogEventListing(user: IDiaprofilHcp) {
    this.navCtrl.push(LogEventListingPage, { hcp: user });
  }

  triggerManageHcpUserModal($event, user?: IDiaprofilHcp) {
    const navParams =
      user !== undefined
        ? { user, modalType: "EDIT" }
        : { modalType: "CREATE" };
    const modal = this.modalCtrl.create(ManageHcpUserModal, navParams, {
      cssClass: "large-modal",
      enableBackdropDismiss: false
    });
    modal.onDidDismiss(data => {
      this.admin.getHcps(this.userState.organizationUuid);
    });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/hcp-users.page/hcp-users.page.ts